import { getV1Accountingmappings } from 'ApiClient/work/hooks/AccountingMappingsHooks/useGetV1Accountingmappings'
import { getV1Activitycategories } from 'ApiClient/work/hooks/ActivityCategoriesHooks/useGetV1Activitycategories'
import { getV1Activitytemplatepackages } from 'ApiClient/work/hooks/ActivityTemplatePackagesHooks/useGetV1Activitytemplatepackages'
import { getV1Agencyrightscategory } from 'ApiClient/work/hooks/AgencyRightsCategoryHooks/useGetV1Agencyrightscategory'
import { getV1Agencyrightssubcategory } from 'ApiClient/work/hooks/AgencyRightsSubCategoryHooks/useGetV1Agencyrightssubcategory'
import { getV1Awards } from 'ApiClient/work/hooks/AwardsHooks/useGetV1Awards'
import { getV1Backlistseasonperiods } from 'ApiClient/work/hooks/BacklistSeasonPeriodsHooks/useGetV1Backlistseasonperiods'
import { getV1Bindingcodes } from 'ApiClient/work/hooks/BindingCodesHooks/useGetV1Bindingcodes'
import { getV1Bookbindingbinders } from 'ApiClient/work/hooks/BookBindingBindersHooks/useGetV1Bookbindingbinders'
import { getV1Bookbindingbindings } from 'ApiClient/work/hooks/BookBindingBindingsHooks/useGetV1Bookbindingbindings'
import { getV1Bookbindingspinetypes } from 'ApiClient/work/hooks/BookBindingSpineTypesHooks/useGetV1Bookbindingspinetypes'
import { getV1Brands } from 'ApiClient/work/hooks/BrandsHooks/useGetV1Brands'
import { getV1Contactroles } from 'ApiClient/work/hooks/ContactRolesHooks/useGetV1Contactroles'
import { getV1Contractformats } from 'ApiClient/work/hooks/ContractFormatsHooks/useGetV1Contractformats'
import { getV1Contracttypes } from 'ApiClient/work/hooks/ContractTypesHooks/useGetV1Contracttypes'
import { getV1Costcenters } from 'ApiClient/work/hooks/CostCentersHooks/useGetV1Costcenters'
import { getV1Countries } from 'ApiClient/work/hooks/CountriesHooks/useGetV1Countries'
import { getV1Coverplacements } from 'ApiClient/work/hooks/CoverPlacementsHooks/useGetV1Coverplacements'
import { getV1Covertypes } from 'ApiClient/work/hooks/CoverTypesHooks/useGetV1Covertypes'
import { getV1Customergroups } from 'ApiClient/work/hooks/CustomerGroupsHooks/useGetV1Customergroups'
import { getV1Customersubgroups } from 'ApiClient/work/hooks/CustomerSubGroupsHooks/useGetV1Customersubgroups'
import { getV1Dispositioncodes } from 'ApiClient/work/hooks/DispositionCodesHooks/useGetV1Dispositioncodes'
import { getV1Efforttypes } from 'ApiClient/work/hooks/EffortTypesHooks/useGetV1Efforttypes'
import { getV1Erpstatuscodes } from 'ApiClient/work/hooks/ErpStatusCodesHooks/useGetV1Erpstatuscodes'
import { getV1Foepapers } from 'ApiClient/work/hooks/FoePapersHooks/useGetV1Foepapers'
import { getV1Governingcodes } from 'ApiClient/work/hooks/GoverningCodesHooks/useGetV1Governingcodes'
import { getV1Imagesheetpapers } from 'ApiClient/work/hooks/ImageSheetPapersHooks/useGetV1Imagesheetpapers'
import { getV1Imagesheetprintings } from 'ApiClient/work/hooks/ImageSheetPrintingsHooks/useGetV1Imagesheetprintings'
import { getV1Insidebulks } from 'ApiClient/work/hooks/InsideBulksHooks/useGetV1Insidebulks'
import { getV1Insidepapers } from 'ApiClient/work/hooks/InsidePapersHooks/useGetV1Insidepapers'
import { getV1Insideprintings } from 'ApiClient/work/hooks/InsidePrintingsHooks/useGetV1Insideprintings'
import { getV1Insideweights } from 'ApiClient/work/hooks/InsideWeightsHooks/useGetV1Insideweights'
import { getV1Interestages } from 'ApiClient/work/hooks/InterestAgesHooks/useGetV1Interestages'
import { getV1Internalcategories } from 'ApiClient/work/hooks/InternalCategoriesHooks/useGetV1Internalcategories'
import { getV1Jacketpapers } from 'ApiClient/work/hooks/JacketPapersHooks/useGetV1Jacketpapers'
import { getV1Laminations } from 'ApiClient/work/hooks/LaminationsHooks/useGetV1Laminations'
import { getV1Languages } from 'ApiClient/work/hooks/LanguagesHooks/useGetV1Languages'
import { getV1Layoutexpressions } from 'ApiClient/work/hooks/LayoutExpressionsHooks/useGetV1Layoutexpressions'
import { getV1Librarycodeprefixes } from 'ApiClient/work/hooks/LibraryCodePrefixesHooks/useGetV1Librarycodeprefixes'
import { getV1Librarycodes } from 'ApiClient/work/hooks/LibraryCodesHooks/useGetV1Librarycodes'
import { getV1Maingroups } from 'ApiClient/work/hooks/MainGroupsHooks/useGetV1Maingroups'
import { getV1Postinggroups } from 'ApiClient/work/hooks/PostingGroupsHooks/useGetV1Postinggroups'
import { getV1Pricegrouppockets } from 'ApiClient/work/hooks/PriceGroupPocketsHooks/useGetV1Pricegrouppockets'
import { getV1Printedcoverpapers } from 'ApiClient/work/hooks/PrintedCoverPapersHooks/useGetV1Printedcoverpapers'
import { getV1Printings } from 'ApiClient/work/hooks/PrintingsHooks/useGetV1Printings'
import { getV1Productgroups } from 'ApiClient/work/hooks/ProductGroupsHooks/useGetV1Productgroups'
import { getV1Productionstatuses } from 'ApiClient/work/hooks/ProductionStatusesHooks/useGetV1Productionstatuses'
import { getV1Publishinghousegroups } from 'ApiClient/work/hooks/PublishingHouseGroupsHooks/useGetV1Publishinghousegroups'
import { getV1Publishinghouses } from 'ApiClient/work/hooks/PublishingHousesHooks/useGetV1Publishinghouses'
import { getV1Publishinglists } from 'ApiClient/work/hooks/PublishingListsHooks/useGetV1Publishinglists'
import { getV1Retailerchannels } from 'ApiClient/work/hooks/RetailerChannelsHooks/useGetV1Retailerchannels'
import { getV1Saleschannels } from 'ApiClient/work/hooks/SalesChannelsHooks/useGetV1Saleschannels'
import { getV1Salesstatus } from 'ApiClient/work/hooks/SalesStatusHooks/useGetV1Salesstatus'
import { getV1Seasonperiods } from 'ApiClient/work/hooks/SeasonPeriodsHooks/useGetV1Seasonperiods'
import { getV1SettingsBattery } from 'ApiClient/work/hooks/SettingsHooks/useGetV1SettingsBattery'
import { getV1SettingsCosttypes } from 'ApiClient/work/hooks/SettingsHooks/useGetV1SettingsCosttypes'
import { getV1SettingsDiscountnumbers } from 'ApiClient/work/hooks/SettingsHooks/useGetV1SettingsDiscountnumbers'
import { getV1SettingsEducation } from 'ApiClient/work/hooks/SettingsHooks/useGetV1SettingsEducation'
import { getV1SettingsErpfields } from 'ApiClient/work/hooks/SettingsHooks/useGetV1SettingsErpfields'
import { getV1SettingsSalestypes } from 'ApiClient/work/hooks/SettingsHooks/useGetV1SettingsSalestypes'
import { getV1Softcoverpapers } from 'ApiClient/work/hooks/SoftCoverPapersHooks/useGetV1Softcoverpapers'
import { getV1Subgroups } from 'ApiClient/work/hooks/SubgroupsHooks/useGetV1Subgroups'
import { getV1Targetgroupthemes } from 'ApiClient/work/hooks/TargetGroupThemesHooks/useGetV1Targetgroupthemes'
import { getV1Targetgroups } from 'ApiClient/work/hooks/TargetGroupsHooks/useGetV1Targetgroups'
import { getV1Taxcodes } from 'ApiClient/work/hooks/TaxCodesHooks/useGetV1Taxcodes'
import { getV1Technicalproductiontypes } from 'ApiClient/work/hooks/TechnicalProductionTypesHooks/useGetV1Technicalproductiontypes'
import { getV1Texttypes } from 'ApiClient/work/hooks/TextTypesHooks/useGetV1Texttypes'

export const accountingMappingsGet = async () => (await getV1Accountingmappings()).data

export const activityCategoriesGet = async () => (await getV1Activitycategories()).data

export const activityTemplatePackagesGet = async () => (await getV1Activitytemplatepackages()).data

export const agencyRightsCategoryGet = async () => (await getV1Agencyrightscategory()).data

export const agencyRightsSubCategoryGet = async () => (await getV1Agencyrightssubcategory()).data

export const awardsGet = async () => (await getV1Awards()).data

export const backlistSeasonPeriodsGet = async () => (await getV1Backlistseasonperiods()).data

export const bindingCodesGet = async () => (await getV1Bindingcodes()).data

export const bookBindingBindersGet = async () => (await getV1Bookbindingbinders()).data

export const bookBindingBindingsGet = async () => (await getV1Bookbindingbindings()).data

export const bookBindingSpineTypesGet = async () => (await getV1Bookbindingspinetypes()).data

export const brandsGet = async () => (await getV1Brands()).data

export const contactRolesGet = async () => (await getV1Contactroles()).data

export const contractFormatsGet = async () => (await getV1Contractformats()).data

export const contractTypesGet = async () => (await getV1Contracttypes()).data

export const costCentersGet = async () => (await getV1Costcenters()).data

export const countriesGet = async () => (await getV1Countries()).data

export const coverPlacementsGet = async () => (await getV1Coverplacements()).data

export const coverTypesGet = async () => (await getV1Covertypes()).data

export const customerGroupsGet = async () => (await getV1Customergroups()).data

export const customerSubGroupsGet = async () => (await getV1Customersubgroups()).data

export const dispositionCodesGet = async () => (await getV1Dispositioncodes()).data

export const effortTypesGet = async () => (await getV1Efforttypes()).data

export const erpStatusCodesGet = async () => (await getV1Erpstatuscodes()).data

export const foePapersGet = async () => (await getV1Foepapers()).data

export const governingCodesGet = async () => (await getV1Governingcodes()).data

export const imageSheetPapersGet = async () => (await getV1Imagesheetpapers()).data

export const imageSheetPrintingsGet = async () => (await getV1Imagesheetprintings()).data

export const insideBulksGet = async () => (await getV1Insidebulks()).data

export const insidePapersGet = async () => (await getV1Insidepapers()).data

export const insidePrintingsGet = async () => (await getV1Insideprintings()).data

export const insideWeightsGet = async () => (await getV1Insideweights()).data

export const interestAgesGet = async () => (await getV1Interestages()).data

export const internalCategoriesGet = async () => (await getV1Internalcategories()).data

export const internalCategoriesByPublishingHouseGet = async (publishingHouseId: string) =>
    (await getV1Internalcategories({ publishingHouseId })).data

export const jacketPapersGet = async () => (await getV1Jacketpapers()).data

export const laminationsGet = async () => (await getV1Laminations()).data

export const languagesGet = async () => (await getV1Languages()).data

export const layoutExpressionsGet = async () => (await getV1Layoutexpressions()).data

export const libraryCodePrefixesGet = async () => (await getV1Librarycodeprefixes()).data

export const libraryCodesGet = async () => (await getV1Librarycodes()).data

export const mainGroupsGet = async () => (await getV1Maingroups()).data

export const postingGroupsGet = async () => (await getV1Postinggroups()).data

export const priceGroupPocketsGet = async () => (await getV1Pricegrouppockets()).data

export const printedCoverPapersGet = async () => (await getV1Printedcoverpapers()).data

export const printingsGet = async () => (await getV1Printings()).data

export const productGroupsGet = async () => (await getV1Productgroups()).data

export const productGroupsByPublishingHouseGet = async (publishingHouseId: string) =>
    (await getV1Productgroups({ publishingHouseId })).data

export const productionStatusesGet = async () => (await getV1Productionstatuses()).data

export const publishingHouseGroupsGet = async () => (await getV1Publishinghousegroups()).data

export const publishingHousesGet = async () => (await getV1Publishinghouses()).data

export const publishingListsGet = async () => (await getV1Publishinglists()).data

export const retailerChannelsGet = async () => (await getV1Retailerchannels()).data

export const salesChannelsGet = async () => (await getV1Saleschannels()).data

export const salesStatusGet = async () => (await getV1Salesstatus()).data

export const seasonPeriodsGet = async () => (await getV1Seasonperiods()).data

export const softCoverPapersGet = async () => (await getV1Softcoverpapers()).data

export const subgroupsGet = async () => (await getV1Subgroups()).data

export const targetGroupsGet = async () => (await getV1Targetgroups()).data

export const targetGroupThemesGet = async () => (await getV1Targetgroupthemes()).data

export const taxCodesGet = async () => (await getV1Taxcodes()).data

export const technicalProductionTypesGet = async () => (await getV1Technicalproductiontypes()).data

export const textTypesGet = async () => (await getV1Texttypes()).data

export const settingsBatteryGet = async () => (await getV1SettingsBattery()).data

export const settingsCostTypesGet = async () => (await getV1SettingsCosttypes()).data

export const settingsDiscountNumbersGet = async () => (await getV1SettingsDiscountnumbers()).data

export const settingsEducationGet = async () => (await getV1SettingsEducation()).data

export const settingsErpFieldsGet = async () => (await getV1SettingsErpfields()).data

export const settingsSalesTypesGet = async () => (await getV1SettingsSalestypes()).data
